import constants from '../constants/constants'

// Create a singleton for the authentication state
const authState = {
  token: constants.keys.LOGGED_OUT_ACCESS_TOKEN
}

class Auth {
  static get hasLocalStorage() {
    return (
      typeof window !== 'undefined' &&
      typeof window.localStorage !== 'undefined'
    )
  }

  static initializeWith(authData) {
    if (authData) {
      Auth.saveApiToken(authData.token)
      Auth.saveUsername(authData.user?.username)
      Auth.saveUserHome(authData.user?.home)
      Auth.saveUserID(authData.user?._id)
    }
  }

  static setItem(key, value) {
    if (typeof value === 'undefined') {
      return
    }

    // We serialise the item as a string for local storage
    const valueString = `${value}`

    if (Auth.hasLocalStorage) {
      window.localStorage.setItem(key, valueString)
    }

    authState[key] = valueString
  }

  static getItem(key) {
    let localStorageItem
    if (Auth.hasLocalStorage) {
      localStorageItem = window.localStorage.getItem(key)
    }

    return localStorageItem || authState[key]
  }

  static removeItem(key) {
    if (Auth.hasLocalStorage) {
      window.localStorage.removeItem(key)
    }

    if (key === 'token') {
      authState[key] = constants.keys.LOGGED_OUT_ACCESS_TOKEN
    } else {
      delete authState[key]
    }
  }

  // authenticate a user - save a token string in Local Storage
  static saveApiToken(token) {
    Auth.setItem('token', token)
  }

  // save user's username
  static saveUsername(username) {
    Auth.setItem('username', username)
  }

  // save user's home
  static saveUserHome(country) {
    Auth.setItem('home', country)
  }

  // save user's search location
  static saveUserSearch(country) {
    Auth.setItem('search', country)
  }

  // save user's id
  static saveUserID(id) {
    Auth.setItem('userID', id)
  }

  // check if a user is authenticated - check if a token is saved in Local Storage
  static isUserApiAuthenticated() {
    const token = Auth.getItem('token')
    return token !== null && token !== constants.keys.LOGGED_OUT_ACCESS_TOKEN
  }

  // deauthenticate a user - remove a token from Local Storage
  static removeApiToken() {
    Auth.removeItem('token')
  }

  // remove user's username
  static removeUsername() {
    Auth.removeItem('username')
  }

  // remove user's userID
  static removeUserID() {
    Auth.removeItem('userID')
  }

  // get token
  static getApiToken() {
    return Auth.getItem('token')
  }

  // get user
  static getUsername() {
    return Auth.getItem('username')
  }

  // get user id
  static getUserID() {
    return Auth.getItem('userID')
  }

  // get user's home
  static getUserHome() {
    return Auth.getItem('home')
  }

  // get user's home
  static getUserSearch() {
    return Auth.getItem('search')
  }
}

export default Auth
